export default __webpack_public_path__ + "static/media/about_area.c5dd7705.jpg";